// A form that re-renders the page it was pressed on, and
// so keeps the customer where they were.
//
// `entrypoints/users.js` scrolls `main` back to the top
// after every page render that is not told otherwise,
// which is right for a navigation and wrong for a form
// that redirects back to the same page to redraw one
// part of it. The discount code's Apply and Remove are
// that form (CAL-522): on a phone the box sits below the
// basket, and every press threw the customer back to the
// top of the cart to scroll down again for the total the
// code had just changed.
//
// Opt-in on the FORM, by `KEEP_SCROLL_ATTRIBUTE`, never
// inferred from the URL: a redirect to the same path is
// also what a refused order form does, and that one
// scrolls to its notice on purpose.
//
// It rides the flag the entrypoint already reads,
// `window.temporarySkipScrollAfterMorph`, which the
// render consumes and `turbo:load` clears. Set when the
// submission starts, because it has ended before the
// redirect it answers is drawn; taken back when it ends
// without one, so a failed press cannot leave the next
// real navigation where the last page was.
export const KEEP_SCROLL_ATTRIBUTE = "data-keep-scroll-on-submit";

const marked = (target) =>
  Boolean(target?.hasAttribute?.(KEEP_SCROLL_ATTRIBUTE));

export default function keepScrollOnSubmit(root = document) {
  root.addEventListener("turbo:submit-start", (event) => {
    if (marked(event.target)) {
      window.temporarySkipScrollAfterMorph = true;
    }
  });

  root.addEventListener("turbo:submit-end", (event) => {
    if (marked(event.target) && !event.detail?.success) {
      window.temporarySkipScrollAfterMorph = false;
    }
  });
}
